import React from 'react';
import { useTheme } from '../context/shared/ThemeContext';
import PageContainer from '../components/common/PageContainer';
import PageSection from '../components/common/PageSection';

const News: React.FC = () => {
  const { themeClasses } = useTheme();

  return (
    <PageContainer>
      <h1 className={`text-2xl font-bold mb-8 ${themeClasses.primaryText}`}>News & Updates</h1>

      <PageSection title="New Feature: Symbolic Insights" emoji="✨">
        <p className={`${themeClasses.secondaryText}`}>
          Track your emotional patterns with our new AI-powered analysis tool. Try it free for 14 days!
        </p>
      </PageSection>

      <PageSection title="Enhanced Privacy Controls" emoji="🔒">
        <p className={`${themeClasses.secondaryText}`}>
          We've added more granular privacy settings to give you better control over your data.
        </p>
      </PageSection>

      <PageSection title="Performance Improvements" emoji="⚡️">
        <p className={`${themeClasses.secondaryText}`}>
          Recent updates have made the app faster and more responsive.
        </p>
      </PageSection>
    </PageContainer>
  );
};

export default News; 